import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

const IndustrySection = () => {
  const { t } = useTranslation('misc');
  
  const industries = t('industry.list', { returnObjects: true }) as string[];

  return (
    <section className="py-20 bg-gradient-subtle">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <Badge variant="outline" className="mb-4">{t('industry.badge')}</Badge>
          <h2 className="text-4xl font-bold mb-6">{t('industry.title')}</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {t('industry.description')}
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
          {industries.map((industry, index) => (
            <Badge 
              key={index} 
              variant="secondary" 
              className="px-4 py-2 text-sm hover:bg-accent hover:text-accent-foreground transition-smooth cursor-default"
            >
              {industry}
            </Badge>
          ))}
        </div>
        
        {/* Animated scrolling effect */}
        <div className="mt-8 overflow-hidden">
          <div className="animate-pulse">
            <div className="flex space-x-4 justify-center">
              {industries.slice(0, 6).map((industry, index) => (
                <Badge 
                  key={index} 
                  variant="outline" 
                  className="whitespace-nowrap opacity-60"
                >
                  {industry}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;